import { EditorState } from 'draft-js'
import { convertEditorStateToKanBoFormat } from 'components/RichText/utils/convert'

export default () => convertEditorStateToKanBoFormat(EditorState.createEmpty())
